// extracted by mini-css-extract-plugin
export default {"desktop":"desktop","ad-site-wrapper":"ad-site-wrapper","footer":"JZRhhtdW","mobile":"mobile"};